<template>
  <div>
    <menuBar></menuBar>
    <div class="cust-container">
      <div>
        <atlanta v-if="selectedMenu === 'Atlanta'"></atlanta>
        <Lacoste v-if="selectedMenu === 'Lacoste'"></Lacoste>
        <Savannah v-if="selectedMenu === 'Savannah'"></Savannah>
        <eLearning v-if="selectedMenu === 'SCADnow'"></eLearning>
      </div>
    </div>
    <goTop></goTop>
    <custFooter></custFooter>
  </div>
</template>

<script>
import menuBar from "../../components/menuBar/index.vue";
import custFooter from "@/components/footer/Footer";
import atlanta from "@/views/locations/components/atlanta/Atlanta";
import Savannah from "@/views/locations/components/savannah/Savannah";
import Lacoste from "@/views/locations/components/lacoste/Lacoste";
import eLearning from "@/views/locations/components/eLearning/eLearning";

export default {
  metaInfo: {
    title: "SCAD", // set a title
  },
  name: "Locations",
  components: {
    menuBar,
    custFooter,
    atlanta,
    Lacoste,
    Savannah,
    eLearning,
  },
  data: function () {
    return {
      selectedMenu: "atlanta",
    };
  },
  created() {
    // console.log(
    //   this.$route.fullPath.substring(this.$route.fullPath.lastIndexOf("/") + 1)
    // );
    this.selectedMenu = this.$route.fullPath.substring(
      this.$route.fullPath.lastIndexOf("/") + 1
    );

    // console.log(this.$route);
    // this.selectedMenu = this.$route.params["name"];
    // var query = this.$route.query;
    // if (query.l) {
    //   this.selectedMenu = query.l;
    // }
  },
  methods: {
    locationMenuItemClick(menu) {
      // this.selectedMenu = menu;
      // this.goTop();
      window.location.href = menu;
    },
    goTop() {
      let timer = null;
      let _this = this;

      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        _this.scrollTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (_this.scrollTop > 5000) {
          _this.scrollTop -= 200;
        } else if (_this.scrollTop > 1000 && _this.scrollTop <= 5000) {
          _this.scrollTop -= 100;
        } else if (_this.scrollTop > 200 && _this.scrollTop <= 1000) {
          _this.scrollTop -= 50;
        } else if (_this.scrollTop > 50 && _this.scrollTop <= 200) {
          _this.scrollTop -= 10;
        } else if (_this.scrollTop > 0 && _this.scrollTop <= 50) {
          _this.scrollTop -= 5;
        } else {
          cancelAnimationFrame(timer);
          return;
        }
        document.body.scrollTop = document.documentElement.scrollTop =
          _this.scrollTop;
        timer = requestAnimationFrame(fn);
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "Locations.less";
</style>

<style lang="less">
.location-banner {
  .swiper-pagination-bullet {
    background: white !important;
  }
  .swiper-pagination-bullet-active {
    background: white !important;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;

    overflow: hidden;
    position: relative;
  }

  .slide-inner {
    width: 100%;
    left: 0;
    top: 0;
    background-size: cover;
    background-position: center;

    img {
      width: 100%;
      display: block;
    }
  }
}
</style>
